import { styled, Typography, WithTheme } from '@material-ui/core'
import { TextField as BaseTextField } from 'formik-material-ui'

interface WithErrorProps extends WithTheme {
  isError?: boolean
}

export const Counter = styled(Typography)(
  ({ theme, isError = false }: WithErrorProps) => ({
    position: 'absolute',
    right: 0,
    bottom: 0,
    marginRight: theme.spacing(3.2),
    marginBottom: theme.spacing(),
    fontSize: 16,
    lineHeight: '19px',
    ...(isError
      ? {
          color: theme.palette.error.main,
          fontWeight: 700,
        }
      : {
          color: theme.palette.common.black,
          fontWeight: 400,
        }),
  })
)

export const TextField = styled(BaseTextField)(({ theme }) => ({
  '& > div': {
    padding: theme.spacing(2.2, 3, 3),
  },
  '& textarea': {
    fontSize: 20,
    lineHeight: '23px',
    boxShadow: 'none',
  },
  '& fieldset': {
    top: 0,
  },
}))
